import { MedplumClient } from "@medplum/core";

import { fetchCptCodeQuestionnaire } from "@/encounters/services/questionnaire";
import { readQuestionnaireResponseHistory } from "@/encounters/services/questionnaire-response";
import { getResourcesFromBundle, joinReferenceString } from "@/utils/medplum";

export const fetchEncounterCPTCodeQuestionnaireResponseVersions = async (
  medplum: MedplumClient,
  encounterId: string,
  clientId: string,
) => {
  const cptCodeQuestionnaire = await fetchCptCodeQuestionnaire(medplum);

  if (!cptCodeQuestionnaire) return [];

  const questionnaireResponseResults = await medplum.searchResources("QuestionnaireResponse", {
    encounter: joinReferenceString("Encounter", encounterId),
    questionnaire: joinReferenceString("Questionnaire", cptCodeQuestionnaire.id!),
    subject: joinReferenceString("Patient", clientId),
    status: "completed,amended,stopped",
  });

  const questionnaireResponses = getResourcesFromBundle(
    "QuestionnaireResponse",
    questionnaireResponseResults.bundle,
  );

  if (!questionnaireResponses) return [];

  return Promise.all(
    questionnaireResponses.map((questionnaireResponse) =>
      readQuestionnaireResponseHistory(medplum, questionnaireResponse.id!),
    ),
  );
};
